import React, { Component } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { fetchImpressAiAuth } from 'store/features/auth/actions';
import { selectCurrentUserId, selectImpressApiDetails } from 'store/features/auth/selectors';

import Button from 'ui/common/button';
import * as messages from './messages';
import { selectIsLoggedIn } from 'store/features/auth/selectors';
import routeTemplates from 'ui/common/routes/templates';

const { request: fetchImpressAiAuthRequest } = fetchImpressAiAuth;

class Chatbot extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  startChatbot() {
    const { skillName, refreshAfterClosing } = this.props;

    this.props.fetchImpressAiAuthRequest({
      skillName,
      selfTrigger: true,
      refreshAfterClosing,
    });
  }

  render() {
    const {
      skillName,
      currentUserId,
      impressApiDetails,
      intl: { formatMessage },
      loggedIn,
      buttonText,
      isLink,
      isBlock,
    } = this.props;

    const skill = impressApiDetails && impressApiDetails[skillName];
    const inProgress = (skill && skill.loading) || !currentUserId;

    if (skillName) {
      const textToShow = buttonText || formatMessage(messages.labels.startQuizbot);
      return (
        <div className={`chatbot-container ${isBlock ? 'd-block w-100' : 'd-inline'}`}>
          {loggedIn ? (
            <Button
              type="button"
              color={isLink ? 'secondary' : 'primary'}
              onClick={this.startChatbot}
              loading={inProgress}
              isReady={false}
              isBlock={isBlock}
            >
              {textToShow}
            </Button>
          ) : (
            <Button
              type="button"
              color={isLink ? 'secondary' : 'primary'}
              to={routeTemplates.auth.login}
              isReady={false}
            >
              {textToShow}
            </Button>
          )}
        </div>
      );
    }
    return null;
  }
}

function mapStateToProps(state, ownProps) {
  const skillName = ownProps.skillName;

  const currentUserId = selectCurrentUserId(state);
  const impressApiDetails = selectImpressApiDetails(state);

  return {
    skillName,
    currentUserId,
    impressApiDetails,
    loggedIn: selectIsLoggedIn(state),
  };
}

const mapDispatchToProps = {
  fetchImpressAiAuthRequest,
};

Chatbot.propTypes = {
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
  skillName: PropTypes.string.isRequired,
};

Chatbot.defaultProps = {
  refreshAfterClosing: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Chatbot));
